import { render, staticRenderFns } from "./sendCodeForRegistrationPage.vue?vue&type=template&id=3e482c54&scoped=true&"
import script from "./sendCodeForRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./sendCodeForRegistrationPage.vue?vue&type=script&lang=js&"
import style0 from "./sendCodeForRegistrationPage.vue?vue&type=style&index=0&id=3e482c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e482c54",
  null
  
)

export default component.exports